"use strict";
import { TokenSelectorFlow } from "components/TokenSelector/types";
import { OnchainItemSectionName } from "components/lists/OnchainItemList/types";
import { OnchainItemListOptionType } from "components/lists/items/types";
import { tradingApiSwappableTokenToCurrencyInfo } from "data/apiClients/tradingApi/utils/tradingApiSwappableTokenToCurrencyInfo";
import { SafetyLevel as GqlSafetyLevel } from "data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { SafetyLevel } from "data/tradingApi/__generated__";
import { ModalName } from "features/telemetry/constants";
import { areCurrencyIdsEqual } from "utils/uniswapCurrencyId";
import { differenceWith } from "utilities/src/primitives/array";
export function createEmptyTokenOptionFromBridgingToken(token) {
  const currencyInfo = tradingApiSwappableTokenToCurrencyInfo(token);
  if (!currencyInfo) {
    return void 0;
  }
  return {
    type: OnchainItemListOptionType.Token,
    currencyInfo,
    balanceUSD: null,
    quantity: null
  };
}
export function toGqlSafetyLevel(safetyLevel) {
  switch (safetyLevel) {
    case SafetyLevel.BLOCKED:
      return GqlSafetyLevel.Blocked;
    case SafetyLevel.MEDIUM_WARNING:
      return GqlSafetyLevel.MediumWarning;
    case SafetyLevel.STRONG_WARNING:
      return GqlSafetyLevel.StrongWarning;
    case SafetyLevel.VERIFIED:
      return GqlSafetyLevel.Verified;
    default:
      return null;
  }
}
export function tokenOptionDifference(currencies, without) {
  if (!currencies) {
    return void 0;
  }
  return differenceWith(currencies, without ?? [], tokenOptionComparator);
}
function tokenOptionComparator(tokenOption, otherTokenOption) {
  return areCurrencyIdsEqual(tokenOption.currencyInfo.currencyId, otherTokenOption.currencyInfo.currencyId);
}
export function mergeSearchResultsWithBridgingTokens(searchResults, bridgingTokens, sectionHeaderString) {
  if (!searchResults || !bridgingTokens || bridgingTokens.length === 0) {
    return searchResults;
  }
  const extractedBridgingTokens = [];
  const extractedSearchResults = searchResults.map((section) => {
    const sectionResults = [];
    section.data.forEach((token) => {
      const isBridgingToken = bridgingTokens.some(
        (bridgingToken) => areCurrencyIdsEqual(token.currencyInfo.currencyId, bridgingToken.currencyInfo.currencyId)
      );
      if (isBridgingToken) {
        extractedBridgingTokens.push(token);
      } else {
        sectionResults.push(token);
      }
    });
    return {
      ...section,
      data: sectionResults
    };
  });
  const bridgingSection = {
    sectionKey: OnchainItemSectionName.BridgingTokens,
    data: extractedBridgingTokens
  };
  const searchResultsSection = extractedSearchResults.find(
    (section) => section.sectionKey === OnchainItemSectionName.SearchResults
  );
  if (bridgingSection.data.length > 0 && searchResultsSection && sectionHeaderString) {
    searchResultsSection.name = sectionHeaderString;
  }
  return [bridgingSection, ...extractedSearchResults].filter((section) => section.data.length > 0);
}
export function isTokenOptionArray(option) {
  return Array.isArray(option) && option.every((item) => item.type === OnchainItemListOptionType.Token);
}
export function isSwapListLoading({
  loading,
  portfolioSection,
  trendingSection,
  isTestnetModeEnabled
}) {
  return loading && (isTestnetModeEnabled ? !portfolioSection : !portfolioSection || !trendingSection);
}
export function flowToModalName(flow) {
  switch (flow) {
    case TokenSelectorFlow.Swap:
      return ModalName.Swap;
    case TokenSelectorFlow.Send:
      return ModalName.Send;
    default:
      return void 0;
  }
}
